module.exports = __webpack_public_path__ + "static/media/cercle-presentation.fb430397.jpg";